<p-confirmDialog [transitionOptions]="'170ms'" [acceptButtonStyleClass]="'btn-dialog-danger'"
  [rejectButtonStyleClass]="'btn-dialog-default'"></p-confirmDialog>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header-light page-title="JULGAMENTO DE PROPOSTAS" fa-icon="gavel"></lib-page-header-light>
        </div>
        <div class="col-md-7">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/licitacoes']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <a [routerLink]="['/licitacoes', entidade.id, 'editar']" routerLinkActive="router-link-active"
            class="btn btn-sm btn-outline-secondary float-right ml-2">
            <i class="fa fa-clipboard"></i>
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-0 mb-2" />

      <div class="card">
        <div class="card-header pt-2 pb-2">
          <div class="row text-muted" style="width: 100%;">
            <div class="col-3">
              <label class="font-weight-bold">Nº Licitação:</label>
              <label class="font-weight-bold ml-2">{{entidade.numero | LICITACAO}}</label>
            </div>
            <div class="col-3">
              <label class="font-weight-bold">Nº Processo:</label>
              <label class="ml-2">{{entidade.processo | LICITACAO}}</label>
            </div>
            <div class="col-6">
              <label class="font-weight-bold">Modalidade:</label>
              <label class="ml-2">{{entidade.modalidade?.nome}}</label>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6 d-flex">
              <label class="mr-2 mt-1">Critério de Julgamento</label>
              <p-selectButton [options]="criteriosJulgamento" formControlName="criterio_julgamento" optionValue="id">
                <ng-template let-criterio>
                  <span class="p-1">{{criterio.nome}}</span>
                </ng-template>
              </p-selectButton>
            </div>
            <div class="col-6">
              <div class="checkbox checbox-switch switch-primary mt-2 float-right">
                <label>
                  <input type="checkbox" formControlName="fracassar_auto" /><span></span>Fracassar automaticamente
                </label>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-4">
              <a class="btn btn-sm btn-link text-primary" data-toggle="collapse" href="#collapseProponente"
                aria-expanded="false" aria-controls="collapseProponente">
                <i class="fa fa-truck"></i> Visualizar Proponentes
              </a>
            </div>
            <div class="offset-4 col-4">
              <button (click)="julgarItens()" class="btn btn-primary btn-sm float-right">
                <i class="fa fa-legal"></i> Julgar Itens
              </button>
              <button class="btn btn-link text-muted btn-sm float-right" data-toggle="modal"
                data-target="#dialogZerarJulgamento">
                <i class="fa fa-history"></i> Zerar Julgamento
              </button>
            </div>
          </div>
          <div class="collapse mt-1" id="collapseProponente">
            <app-proponente [(entidade)]="entidade" [login]="login"></app-proponente>
          </div>
          <div class="row">
            <div class="col-md-12">
              <p-fieldset
                [legend]="memorial.ordem + ' - ' + (memorial.quantidade) + 'x ' + funcaoService.abreviarStr(memorial?.descricao, 100, true) + ' (' + memorial.unidade + ')'"
                [toggleable]="memorial.propostas?.length > 0" [collapsed]="0 >= memorial.propostas?.length"
                *ngFor="let memorial of entidade?.itens">
                <a *ngIf="mostrarBotaoEmpate(memorial)" (click)="abrirModalDividirEmpate(memorial)"
                  style="margin-top: -.5rem" class="btn btn-sm btn-outline-success mb-2 float-right">
                  <i class="fa fa-object-ungroup"></i> Dividir Itens
                </a>
                <table class="table table-sm table-eddy mb-0">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 42%">Favorecido</th>
                      <th scope="col" class="text-center">Qtd.</th>
                      <th scope="col" style="width: 170px">Marca</th>
                      <th scope="col" class="text-center" style="width: 90px">Valor Ref.</th>
                      <th scope="col" class="text-center" style="width: 90px">Valor Unit.</th>
                      <th scope="col" class="text-center">Total</th>
                      <th scope="col" class="text-center" style="width: 100px">Situação</th>
                      <th scope="col" class="text-center" style="width: 60px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let proposta of memorial.propostas"
                      [class]="proposta.situacao === 'EMPATADO' ? 'text-danger' : ''">
                      <td>{{proposta.proponente?.favorecido?.nome}}</td>
                      <td class="text-right">{{+proposta.quantidade_final | number:'1.0-0'}}</td>
                      <td>{{proposta.marca}}</td>
                      <td class="text-right">{{+memorial.valor_referencia | number:'1.4-4'}}</td>
                      <td class="text-right">{{+proposta.valor_unitario | number:'1.4-4'}}</td>
                      <td class="text-right">
                        {{(+proposta.quantidade_final > 0 ? +proposta.quantidade_final : +memorial.quantidade) *
                        +proposta.valor_unitario | number:'1.4-4'}}
                      </td>
                      <td class="text-center">
                        <span
                          [class]="'badge badge-' + (obterEstiloProposta(proposta))">{{obterNomeProposta(proposta)}}</span>
                      </td>
                      <td class="text-center">
                        <i class="fa fa-thumbs-up m-1 float-left text-success" style="cursor: pointer;"
                          title="Atribuir como vencedor" *ngIf="mostrarBotaoSituacao(proposta, 'VENCEDOR')"
                          (click)="atribuirSituacao(proposta, memorial, 'VENCEDOR')"></i>
                        <i class="fa fa-thumbs-down m-1 float-right text-danger" style="cursor: pointer;"
                          title="Atribuir como desclassificado"
                          *ngIf="mostrarBotaoSituacao(proposta, 'DESCLASSIFICADO')"
                          (click)="atribuirSituacao(proposta, memorial, 'DESCLASSIFICADO')"></i>
                        <i class="fa fa-undo m-1 text-primary" style="cursor: pointer;"
                          title="Voltar item para classificado" *ngIf="mostrarBotaoSituacao(proposta, 'CLASSIFICADO')"
                          (click)="atribuirSituacao(proposta, memorial, 'CLASSIFICADO')"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </p-fieldset>
            </div>
          </div>
        </div>
      </div>

      <!-- <pre *ngIf="entidade">{{ entidade | json}}</pre> -->
    </div>
  </form>
</div>

<div class="modal fade" id="dialogDividirEmpate" data-backdrop="static" data-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-success">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Dividir Itens Empatados</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="row">
          <div class="col-8">
            <span class="font-weight-bold">Item: </span>
            <span>{{memorialEmpate?.descricao}}</span>
          </div>
          <div class="col-4">
            <span class="font-weight-bold">Qtde: </span>
            <span>{{memorialEmpate?.quantidade}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-eddy mb-0">
              <thead>
                <tr>
                  <th scope="col" style="width: 80%">Favorecido</th>
                  <th scope="col" style="width: 90px" class="text-center">Qtd.</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let proposta of itensEmpatados">
                  <td>{{proposta.proponente?.favorecido?.nome}}</td>
                  <td>
                    <input [(ngModel)]="proposta.quantidade_final" [ngModelOptions]="{standalone: true}" type="text"
                      class="form-control form-control-sm text-right" unmask="typed" [imask]="imaskQtd">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="dividirEmpate()" class="btn btn-sm btn-success">Confirmar</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="dialogZerarJulgamento" data-backdrop="static" data-keyboard="false" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-danger">
        <h5 class="modal-title" id="title" style="font-size: 1rem;">Zerar Julgamentos</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-2">
        <div class="row">
          <div class="col-12">
            <a class="btn btn-sm btn-link text-muted" (click)="toggleItensJulgamento(true)">Marcar todos</a> /
            <a class="btn btn-sm btn-link text-muted" (click)="toggleItensJulgamento(false)">Desmarcar todos</a>
            <div class="table-responsive">
              <table class="table table-eddy">
                <tbody>
                  <tr *ngFor="let item of itensZerar">
                    <td class="text-center">
                      <div class="checkbox checbox-switch switch-danger" style="text-align: right;">
                        <label style="margin: 0; text-align: left;">
                          <input type="checkbox" [(ngModel)]="item.marcado"
                            [ngModelOptions]="{standalone: true}" /><span></span> &nbsp;&nbsp;
                        </label>
                      </div>
                    </td>
                    <td>
                      {{item.memorial.ordem}} - {{item.memorial.quantidade}}x
                      {{funcaoService.abreviarStr(item.memorial?.descricao, 70, true)}} ({{item.memorial.unidade}})
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="zerarJulgamento()" class="btn btn-sm btn-danger">Confirmar</button>
        <button type="button" class="btn btn-link" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>